module.exports = __webpack_public_path__ + "static/media/Avatar4.57a9d20a.png";